import React, { useEffect, useState } from 'react';
import config from '../../../config';

function DueComponent() {
    const [totalDue, setTotalDue] = useState(0);
    const [unpaidCount, setUnpaidCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.BASE_URL}/total-due-and-unpaid-count`);
                const data = await response.json();
                setTotalDue(data.totalDue.toFixed(2));
                setUnpaidCount(data.unpaidCount);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <div>
            <table className="table table-hover table-striped mb-0" style={{ width: '100px' }}>
                <tbody className="bg-light">
                    <tr>
                        <td className="text-start ps-4 fw-bold">Total Debts</td>
                        <td className="text-end pe-4 font-monospace">
                            LKR {totalDue}
                        </td>
                    </tr>
                    {/* <tr>
                        <td className="text-start ps-4 fw-bold">Dated Cheques Values</td>
                        <td className="text-end pe-4 font-monospace">
                            LKR  
                        </td>
                    </tr> */}
                    <tr>
                        <td className="text-start ps-4 fw-bold">No. of unpaid invoices</td>
                        <td className="text-end pe-4 font-monospace fw-bold ">
                            {unpaidCount}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default DueComponent;